import * as React from "react"
import { Input as InputPrimitive } from "@base-ui/react/input"
import { cn } from "cn"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "w-full min-w-0 border py-1 transition-all outline-none",
        "file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        "placeholder:text-muted-foreground/70",
        
        // ⬇️ استایل‌های اختصاصی که از شما گرفتم (اعمال شده برای کل سایت)
        "h-8 text-xs px-3 bg-background border-border rounded-md shadow-none font-normal",
        "hover:border-border/80 focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary/30",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50",
        "aria-invalid:border-destructive aria-invalid:ring-1 aria-invalid:ring-destructive/20",
        "dark:bg-input/30 dark:disabled:bg-input/80 dark:aria-invalid:border-destructive/50",
        
        className
      )}
      {...props}
    />
  )
}

export { Input }